import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted } from 'vue';
import { fetchSvgText } from '@/components/fpComponents/svgTextCache';

interface IconProps {
  src: string | Promise<string>;
  width?: string | number;
  height?: string | number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FpSvgIcon',
  props: {
    src: null,
    width: null,
    height: null
  },
  setup(__props: any) {

const props = __props as {
  src: string | Promise<string>;
  width?: string | number;
  height?: string | number;
};



const svgContent = ref<string>('');

const parseSvgText = (text: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'image/svg+xml');
  const svg = doc.querySelector('svg');

  if (svg) {
    if (props.width) {
      svg.setAttribute('width', String(props.width));
    } else if (props.height) {
      svg.removeAttribute('width');
    }

    if (props.height) {
      svg.setAttribute('height', String(props.height));
    } else if (props.width) {
      svg.removeAttribute('height');
    }
  }

  return svg?.outerHTML ?? '';
};

const loadSvg = async(): Promise<void> => {
  const src = props.src;
  try {
    const text: string = typeof src === 'string' ? await fetchSvgText(src) : await src;
    if (src !== props.src) return;

    svgContent.value = parseSvgText(text);
  } catch (error) {
    if (src !== props.src) return;
    console.error('Błąd ładowania SVG', error);
    svgContent.value = '';
  }
};

onMounted(loadSvg);
watch(() => props.src, loadSvg);

return { __sfc: true,props, svgContent, parseSvgText, loadSvg }
}

})